export const productCardFields = [
  'onSale',
  'averageRating',
  'bestSeller',
  'newProduct',
  'claim',
  'code',
  'discountedPrice',
  'ecoTaxPrice(formattedValue,value)',
  'formattedDiscountValue',
  'isProductComparator',
  'name',
  'numberOfReviews',
  'price',
  'promoMessage',
  'promoMessageEnabled',
  'stock(FULL)',
  'topBenefits(BASIC)',
  'url',
  'externalLogistician',
  'topCategoryName',
  'subCategoryName',
  'sisCategory',
  'sisSubCategory',
  'accessoryCategorisation',
  'isAccessory',
  'productGenre',
  'shippingIncluded',
  'gsebAverageRating',
  'gsebNumberOfReviews',
  'replacedBy',
  'replacementProductURL',
  'strikethroughPrice',
  'indexFollow',
  'agecLaw',
  'repairabilityIndex',
  'badges',
  'brand',
  'recommendedPrice',
  'variantOptions',
  'baseProduct',
  'primaryImages(FULL)'
];
